import { c as _c } from "react/compiler-runtime";
import ButtonComponent, { Icon, IconSize } from '../button/button.component';
import { ButtonType } from '../types/ButtonType';
import { Link } from '@spa/lib/react/hooks/useLinkAttributes';
import LinkButtonComponent from '../link-button/link-button.component';
import { ReactNode } from 'react';
type IsButtonProps = {
  readonly condition: true;
  readonly link?: Link;
};
type IsLinkProps = {
  readonly condition: false;
  readonly link: Link;
};
type ConditionalButtonProps = {
  readonly text?: ReactNode;
  readonly bold?: boolean;
  readonly buttonType: ButtonType;
  readonly dataProductId?: string;
  readonly dataTestId?: string;
  readonly dataTrackId?: string;
  readonly disabled?: boolean;
  readonly hasPopup?: boolean;
  readonly iconLeft?: Icon;
  readonly iconRight?: Icon;
  readonly iconSize?: IconSize;
  readonly looksDisabled?: boolean;
  readonly noStyle?: boolean;
  readonly onButtonClick?: () => void;
  readonly onLinkClick?: () => void;
  readonly pressed?: boolean;
  readonly preventForwarding?: boolean;
  readonly showSpinner?: boolean;
  readonly title?: string;
  readonly type?: 'button' | 'submit';
  readonly underline?: boolean;
  readonly uppercase?: boolean;
} & (IsButtonProps | IsLinkProps);
export const ConditionalButton = props => {
  const $ = _c(4);
  const {
    condition
  } = props;
  if (condition) {
    let t0;
    if ($[0] !== props) {
      t0 = <ButtonComponent {...props} onClick={props.onButtonClick} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <LinkButtonComponent {...props} onClick={props.onLinkClick} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};